import { Component, Input, OnInit, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { HuntPackageRecord } from '@cyborg-monorepo/hunter/common'
import { DialogRef, DialogService } from '@hyperkit'

import { AuthService } from '../../../../auth/auth.service'
import {
  TrackingEventEnum,
  TrackingService,
} from '../../../../tracking/tracking.service'
import { HuntPackageService, UserService } from '../../services'
import { CalendlyService } from '../../services/calendly.service'
import { PremiumDialogComponent } from '../dialogs/premium-dialog/premium-dialog.component'
@Component({
  standalone: false,
  selector: 'cyborg-trial-lock-unlock',
  templateUrl: './trial-lock-unlock.component.html',
  styleUrls: ['./trial-lock-unlock.component.scss'],
})
export class TrialLockUnlockComponent implements OnInit {
  private userService = inject(UserService)
  dialog = inject(DialogService)
  calendlyService = inject(CalendlyService)
  trackingService = inject(TrackingService)
  private huntPackageService = inject(HuntPackageService)

  public locked$: Observable<boolean>
  @Input() public huntPackage: Partial<HuntPackageRecord>
  public ngOnInit(): void {
    this.locked$ = this.userService.profile$.pipe(
      map((profile) => {
        return !this.huntPackageService.huntPackageIsAccessibleForUser(
          this.huntPackage as HuntPackageRecord,
          profile,
        )
      }),
    )
  }

  public openPremiumDialog(): void {
    this.trackingService.trackEvent(
      TrackingEventEnum.COMMUNITY_PREMIUM_DIALOG_OPENED,
    )
    const dialogRef: DialogRef = this.dialog.open(PremiumDialogComponent, {
      panelClass: 'full-panel',
    })

    dialogRef.afterClosed().subscribe((talkToCyborg: boolean) => {
      if (talkToCyborg) {
        this.calendlyService.talkToCyborg()
      } else {
        this.trackingService.trackEvent(
          TrackingEventEnum.COMMUNITY_PREMIUM_DIALOG_ABANDONED,
        )
      }
    })
  }
}
